import { useState } from 'react'
import { generateError } from '../../helpers/errors'
import { mutations } from '../../resources'
import { DeleteMessagingConversationMessage } from '../../resources/messages/types'
import { deleteMessagingMessage } from '../../store/messaging/actions'
import { useDispatch } from '../redux'

export const useDeleteConversationMessage = () => {
    const [inProgress, setInProgress] = useState(false)
    const dispatch = useDispatch()

    const deleteConversationMessage = (payload: DeleteMessagingConversationMessage): Promise<void> => {
        setInProgress(true)
        return mutations
            .deleteMessagingConversationMessage(payload)
            .then(() => {
                dispatch(deleteMessagingMessage({ conversation: payload.id, messageId: payload.messageId }))
            })
            .catch((error) => {
                throw generateError(error)
            })
            .finally(() => {
                setInProgress(false)
            })
    }

    return {
        deleteConversationMessage,
        inProgress,
    }
}
